export interface BaseTableColumns {
    id: number;
    service: string;
    date: string;
}

export class RequesterTableColumns implements BaseTableColumns {
    constructor(public id: number, public service: string, public date: string,public closedDate?:string) {}
}
